export default __webpack_public_path__ + "static/media/home_connect-24px-grey.f6820673.svg";